/** @typedef {import('../../../@types/api-response').APIResponse} APIResponse */

import exodusInstance from 'lib/api/instances/exodus';
import { API_EXODUS_URL } from 'constants/api';

const requestExodus = exodusInstance.noAlert;

const GET_EBOOK_CATALOGUE = `${API_EXODUS_URL}/ebook`;
const GET_EBOOK_DETAIL = `${API_EXODUS_URL}/ebook/`;
const GET_EBOOK_CATEGORIES = `${API_EXODUS_URL}/ebook/categories/`;

/**
 * Get Ebook Catalogue
 * @returns {APIResponse}
 */
const getEbookCatalogue = () => requestExodus.get(GET_EBOOK_CATALOGUE);

/**
 * Get Ebook Detail
 * @param {string} ebookUrl
 * @returns {APIResponse}
 */
const getEbookDetail = (ebookUrl: string) =>
  requestExodus.get(`${GET_EBOOK_DETAIL}${ebookUrl}`);

/**
 * Get Ebook Categories
 * @returns {APIResponse}
 */
const getEbookCategories = () => requestExodus.get(GET_EBOOK_CATEGORIES);

export { getEbookCatalogue, getEbookDetail, getEbookCategories };
